import { sleepAsync } from "../../functions";

export async function relativeScroll(
    scrollableEl: HTMLDivElement,
    targetEl: HTMLElement,
    offset: number = 0,
    noSmooth?: boolean,
    canDisturbCurrentScroll?: boolean
) {
    const startFromBottom = checkReachedBottom(scrollableEl);

    let timeToWait = 100;
    if (
        (await checkScrolling(scrollableEl, timeToWait)) &&
        !canDisturbCurrentScroll
    ) {
        return; // Don't disturb user's scroll operation
    }

    while (true) {
        if (timeToWait < 500) {
            timeToWait += 10;
        }

        const targetTop = targetEl.getBoundingClientRect().top;
        const scrollableTop = scrollableEl.getBoundingClientRect().top;
        const dif = scrollableTop + offset - targetTop;

        const reachedTarget = dif ** 2 < 3;
        const reachedBottom =
            !startFromBottom && checkReachedBottom(scrollableEl);

        if (reachedTarget || reachedBottom) {
            return;
        }

        const stillScrolling = await checkScrolling(scrollableEl, timeToWait);
        if (!stillScrolling) {
            scrollableEl.scrollTo({
                top:
                    targetTop + scrollableEl.scrollTop - scrollableTop - offset,
                behavior: noSmooth ? undefined : "smooth",
            });
        }

        if (startFromBottom) {
            if (!(await checkScrolling(scrollableEl, timeToWait))) {
                return;
            }
        }
        console.log("scrolling");
    }
}

function checkReachedBottom(scrollableEl: HTMLDivElement) {
    return (
        Math.floor(scrollableEl.scrollHeight) -
            Math.ceil(scrollableEl.offsetHeight) -
            Math.ceil(scrollableEl.scrollTop) <=
        1
    );
}

async function checkScrolling(
    scrollableEl: HTMLDivElement,
    timeToWait: number
) {
    const previousScrollTop = scrollableEl.scrollTop;
    await sleepAsync(timeToWait);
    return scrollableEl.scrollTop !== previousScrollTop;
}
